export enum DocumentViewMode {
	Grid = 'grid',
	Stack = 'stack',
	List = 'list'
}

export enum ActionMode {
	View = 'view',
	Favorite = 'favorite',
	Add = 'add',
	Edit = 'edit',
	Delete = 'delete'
}

export enum DocumentTypeFilter {
	All = 'all',
	Video = 'video',
	Image = 'image'
}

export enum SortSequence {
	Ascending = 'asc',
	Descending = 'desc'
}

export interface Map<T> {
	[key: string]: T;
}
